// Design tokens de la landing pública — traducidos 1:1 del :root del
// handoff (design_handoff_talenv_landing/Talenv Landing Premium.html).
// Viven acá (no en tailwind.config.ts) para no tocar los tokens globales
// del dashboard, que ya usan nombres genéricos (bg/text/muted/accent) con
// valores completamente distintos.

export const L = {
  // Brand
  violet: "#6C5CFF",
  violetBright: "#8979FF",
  violetSoft: "#ECE8FF",
  violetDeep: "#4E3FE8",
  lime: "#D9FF5B",
  limeDeep: "#B6E235",

  // Surfaces
  bg: "#FAF7F2",
  bgWarm: "#F2EDE5",
  bgDark: "#1C1850",
  bgDeep: "#15103D",
  card: "#FFFFFF",

  // Ink (texto + bordes)
  ink: "#15103D",
  ink2: "#2A2553",
  inkSoft: "#6B6982",
  inkFaint: "#A19FB6",
  line: "rgba(21,16,61,0.08)",
  lineStrong: "rgba(21,16,61,0.14)",
  lineDark: "rgba(255,255,255,0.08)",

  // Signal
  green: "#1F9D6F",
  greenSoft: "#DCF3E9",
  coral: "#FF6B5C",
  amber: "#F0A12B",
  blue: "#3E7BFF",

  // Tipografía — perfil "Calendly" del handoff (el que efectivamente se ve
  // al abrir el HTML: <body class="profile-calendly">, confirmado contra
  // capturas reales). Reusa las variables ya cargadas en app/layout.tsx —
  // no hace falta ninguna fuente nueva.
  fontDisplay: "var(--font-jakarta), system-ui, -apple-system, BlinkMacSystemFont, sans-serif",
  fontBody: "var(--font-inter), system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
  fontMono: "var(--font-jetbrains), ui-monospace, 'Cascadia Mono', 'Consolas', monospace",
} as const;

export const SHADOWS = {
  cardSm: "0 14px 30px -16px rgba(21,16,61,0.16)",
  cardLg: "0 24px 48px -16px rgba(21,16,61,0.18)",
  shot: "0 30px 60px -24px rgba(21,16,61,0.18), 0 60px 100px -40px rgba(21,16,61,0.22)",
  violetBtn: "0 1px 0 rgba(255,255,255,0.2) inset, 0 8px 22px -10px rgba(108,92,255,0.7)",
  popular: "0 24px 50px -24px rgba(107,92,255,0.45)",
} as const;
